/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'
import Step1 from '../assets/images/process/find.png'
import Step2 from '../assets/images/process/laptop.png'
import Step3 from '../assets/images/process/tank-top.png'
import Step4 from '../assets/images/process/mobile.png'
import Step5 from '../assets/images/process/delivery.png'

function Process() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>The Etho Process</h2>
						</div>
					</div>
				</div>
			</Section>

			<section id='process__section'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-lg-8'>
							<div className='process-1'>
								<div className='process__item'>
									<img src={Step1} alt='' />
									<h4>The Search</h4>
									<p>
										We find the best ethical brands from
										around the world.
									</p>
								</div>
								<div className='process__item'>
									<img src={Step2} alt='' />
									<h4>Pre-Checks</h4>
									<p>
										We do pre-checks, questionnaires, or
										site visits to ensure that sellers meet
										our ethical standards.
									</p>
								</div>
								<div className='process__item'>
									<img src={Step3} alt='' />
									<h4>Sellers</h4>
									<p>
										Our handpicked sellers list their shops
										and products on The Etho.
									</p>
								</div>
								<div className='process__item'>
									<img src={Step4} alt='' />
									<h4>You Shop!</h4>
									<p>
										Shop from a variety of products and
										sellers with a single cart secure
										checkout.
									</p>
								</div>
								<div className='process__item'>
									<img src={Step5} alt='' />
									<h4>Deliver Your Selections</h4>
									<p>
										Your purposeful orders are shipped
										directly from our artisans to your
										doorstep.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Section id='ethical-verification__section'>
				<div className='col-12'>
					<h4>Our Ethical Verification Process:</h4>
					<p>
						Because we carry a variety of products from sellers of
						different sizes and origins (the beauty of The Etho), we
						found it necessary to create our own verification
						process. You can shop comfortably knowing that we have
						done all the screening for you.
					</p>
					<ol>
						<li>
							<span className='semi-bold'>Pre-Check:</span>We
							conduct a general pre-check on each seller’s
							certifications and ethical claims by having
							discussions with the owners and management and
							referencing information available online.
						</li>
						<li>
							<span className='semi-bold'>Agreement:</span>
							We share our 7 Core Ethical Principles and
							verification process with sellers and ask their
							consent to The Etho’s Terms of Use and Seller
							Expectations.
						</li>
						<li>
							<span className='semi-bold'>Questionnaire:</span>
							Sellers not possessing any of the official Fair
							Trade or Organic certifications (having a third
							party auditing or internal monitoring system
							reaching all the way to the worker level) are
							required to fill in The Etho's Ethical Production
							Questionnaire. It maps the functions and production
							chain of sellers' products and aspects related to
							The Etho's Core Ethical Principles.
							<span className='semi-bold'>
								The comprehensive questionnaire is based on
								auditing questions used in Fair Trade, covering
								environmental and employer welfare-related
								issues through 29 questions.
							</span>
							<ol>
								<li>
									The information from each seller is analyzed
									individually and any additional information
									needs or needs for improvements are taken up
									with the seller. After providing all the
									needed information and completing the
									process successfully, the seller's products
									receive The Etho verified status in our
									online shop. The questionnaire/production
									update will be done annually, on top of
									regular communication with the sellers.
								</li>
								<li>
									In case a non-certified seller refuses to
									share the requested information, The Etho
									abstains from selling these products.
								</li>
								<li>
									A periodical analysis and summary on the
									ethical questionnaire responses (keeping the
									sellers' details anonymous) will be shared
									with all sellers for mutual learning and
									sharing.
								</li>
							</ol>
						</li>
						<li>
							<span className='semi-bold'>Impact Reporting</span>
							The Etho will report on its activities and impact in
							an annual impact report, released in the first
							quarter of the following year.{' '}
						</li>
					</ol>
				</div>
			</Section>
		</div>
	)
}

export default Process
